import { GenIcon } from '../helpers/IconBase.es.js';

const DiscountTagColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 9.5C21 9.914 20.664 10.25 20.25 10.25C19.395 10.25 18.75 10.895 18.75 11.75C18.75 12.605 19.395 13.25 20.25 13.25C20.664 13.25 21 13.586 21 14V17.75C21 18.164 20.664 18.5 20.25 18.5H3.75C3.336 18.5 3 18.164 3 17.75V14C3 13.586 3.336 13.25 3.75 13.25C4.605 13.25 5.25 12.605 5.25 11.75C5.25 10.895 4.605 10.25 3.75 10.25C3.336 10.25 3 9.914 3 9.5V5.75C3 5.336 3.336 5 3.75 5H20.25C20.664 5 21 5.336 21 5.75V9.5ZM10.5 9.125C10.5 8.504 9.996 8 9.375 8C8.754 8 8.25 8.504 8.25 9.125C8.25 9.746 8.754 10.25 9.375 10.25C9.996 10.25 10.5 9.746 10.5 9.125ZM13.5 14.375C13.5 14.996 14.004 15.5 14.625 15.5C15.246 15.5 15.75 14.996 15.75 14.375C15.75 13.754 15.246 13.25 14.625 13.25C14.004 13.25 13.5 13.754 13.5 14.375ZM9.53026 15.2802C9.23742 15.5731 8.76261 15.5731 8.46976 15.2802C8.17692 14.9874 8.17692 14.5126 8.46976 14.2197L14.4698 8.2197C14.7626 7.92685 15.2374 7.92685 15.5303 8.2197C15.8231 8.51255 15.8231 8.98735 15.5303 9.2802L9.53026 15.2802Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "5",
              x2: "12",
              y2: "18.5",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { DiscountTagColored };
